// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-00e0cf38] {\n  width: 100%;\n  height: 100%;\n}\n.container .title[data-v-00e0cf38] {\n  color: #169bd5;\n}\n.container .label-class[data-v-00e0cf38] {\n  display: inline-block;\n  width: 80px;\n  text-align: right;\n  margin-right: 10px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
